import requests from 'api/index';

const prefixURL = '/employee/memberadmin';

export default {
  getReadEmployeeInfo: () => requests.post(`${prefixURL}/rest/v1/emp/readEmployeeByUserId`, {}), // 중복
  modifyEmployeeInfo: memberVO => requests.post(`${prefixURL}/rest/v1/emp/update`, memberVO),
  getCheckPassword: (payload, utoken) => requests.postHTTPS(`${prefixURL}/rest/v1/pwd/check`, payload, utoken),
  modifyPassword: (payload, utoken) =>
    requests.postHTTPS(`${prefixURL}/rest/v1/pwd/update/user/financial`, payload, utoken),
  getPwdHintList: () => requests.post(`${prefixURL}/rest/v1/pwd/hint/list`, {}),
  modifyPwdHintList: payload => requests.post(`${prefixURL}/rest/v1/pwd/hint/update`, payload),
  getCheckBeforeChange: () => requests.get(`${prefixURL}/rest/v1/id/checkbeforechange`),
  getIdValidation: payload => requests.post(`${prefixURL}/rest/v1/id/validate`, payload),
  getIdCheck: payload => requests.post(`${prefixURL}/rest/v1/id/doublecheck`, payload),
  modifyIdChange: payload => requests.post(`${prefixURL}/rest/v1/id/change`, payload),
  modifyIdComplete: payload => requests.post(`${prefixURL}/rest/v1/id/complete`, payload),
  getTermAgreementList: () => requests.post(`${prefixURL}/rest/v2/terms/agmt/list`, {}),
  getTermsVersion: payload => requests.get(`${prefixURL}/rest/v2/nosession/terms/version?trmsCd=${payload}`),
  getTermsContents: payload =>
    requests.get(`${prefixURL}/rest/v2/nosession/terms/cn?trmsCd=${payload.trmsCd}&trmsVerVal=${payload.trmsVerVal}`),
  /* kms */
  // 패스워드 체크
  getCheckPasswordKms: (payload, utoken) =>
    requests.postHTTPS(`${prefixURL}/rest/v1/kms/regist/check/pwd`, payload, utoken),
  // 핀 입력 후 저장
  addPinPassword: (payload, utoken) => requests.postHTTPS(`${prefixURL}/rest/v1/kms/regist/save`, payload, utoken),
  // 패스워드 변경 (기존 화면)
  modifyPasswordKms: (payload, utoken) => requests.postHTTPS(`${prefixURL}/rest/v1/kms/update`, payload, utoken),
  // KMS 해제 (신규 화면)
  removeKmsPassword: (payload, utoken) => requests.postHTTPS(`${prefixURL}/rest/v1/kms/unregister`, payload, utoken),
  getCompanyPolicy: payload => requests.get(`${prefixURL}/rest/v1/freemium/comp/policy?compCd=${payload}`),
  modifyPasswordInitial: payload => requests.post(`${prefixURL}/rest/v1/pwd/update/initial`, payload),
};
